(function ($) {
    $(() => {
        $('.youtube-player').on('click', function () {
            $(this).html(
                `<iframe src="https://www.youtube.com/embed/${$(this).data(
                    'id'
                )}?autoplay=1&amp;rel=0" frameborder="0" allowfullscreen="1"></iframe>`
            );
        });
    });
})(jQuery);
